/**
 * Detect whether a stored execution was run in AI / dynamic mode (vs deterministic script replay).
 * Supports explicit flags from NLP Lambda payloads and inference from flattened step shape.
 */
export function detectAiDynamicExecution(data) {
    if (!data || typeof data !== 'object') return false;

    if (data.isDynamic === true || data.is_dynamic === true) return true;
    if (data.runMode === 'AI_DYNAMIC' || data.run_mode === 'AI_DYNAMIC') return true;

    const ex = data.execution;
    if (ex && typeof ex === 'object') {
        if (ex.isDynamic === true || ex.is_dynamic === true) return true;
        if (ex.runMode === 'AI_DYNAMIC' || ex.run_mode === 'AI_DYNAMIC') return true;
    }

    const steps =
        (Array.isArray(data.execution_steps) && data.execution_steps.length > 0 && data.execution_steps) ||
        (Array.isArray(data.executionSteps) && data.executionSteps.length > 0 && data.executionSteps) ||
        null;

    if (steps && steps.some(inferDynamicShape)) {
        return true;
    }

    return false;
}

function inferDynamicShape(step) {
    if (!step || typeof step !== 'object') return false;
    if (step.automationPhase === 'mcp' || step.automationPhase === 'evaluation') return true;
    const id = step.id;
    return typeof id === 'string' && id.startsWith('dynamic-');
}
